// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__ZMaU_","wrapper":"styles_wrapper__dnGro","description":"styles_description___skqT"};